<ng-template #settingsTemplate>
    <app-tool-setting label="Waarden" class="slider-groups">
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.H" label="H"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.T" label="T"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.E" label="E"></app-range-slider>
        </div>
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.t" label="t"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.h" label="h"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.d" label="d"></app-range-slider>
        </div>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg id="Laag_1"
         data-name="Laag 1"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 300 96.68"
         style="height: 150px;"
        >
        <defs>
            <style>.htethd1{fill:#eaf4fb;}.htethd2{fill:#1d1d1b;}.htethd3{fill:none;stroke:#0090c9;stroke-width:1.5px;}.htethd4{fill:#0090c9;}.htethd5{font-size:28px;font-family:UniversLTStd, Univers LT Std;}</style>
        </defs>
        <title>DBS_HTE_thd_schema</title>
        <rect class="htethd1"
              y="1.68"
              width="145"
              height="47" />
        <rect class="htethd1"
              x="155"
              y="1.68"
              width="145"
              height="47" />
        <path class="htethd2"
              d="M71,36.13V18.29H64.19V15.91H80.51v2.38H73.74V36.13Z"
              transform="translate(0 -1.32)" />
        <path class="htethd2"
              d="M113.89,15.91h12.68v2.38h-9.88v6.3h9.41V27h-9.41v6.72H126.8v2.46H113.89Z"
              transform="translate(0 -1.32)" />
        <path class="htethd2"
              d="M18.72,15.91v8.68h9.6V15.91h2.8V36.13h-2.8V27h-9.6v9.13h-2.8V15.91Z"
              transform="translate(0 -1.32)" />
        <line class="htethd3"
              x1="48.58"
              y1="0.68"
              x2="48.58"
              y2="96.68" />
        <line class="htethd3"
              x1="96.75"
              y1="0.68"
              x2="96.75"
              y2="96.68" />
        <line class="htethd3"
              x1="202.49"
              y1="0.68"
              x2="202.49"
              y2="96.68" />
        <line class="htethd3"
              x1="250.66"
              y1="0.68"
              x2="250.66"
              y2="96.68" />
        <rect class="htethd4"
              x="144.25"
              y="0.68"
              width="1.5"
              height="96" />
        <rect class="htethd4"
              x="154.25"
              y="0.68"
              width="1.5"
              height="96" />
        <line class="htethd3"
              y1="49.18"
              x2="300"
              y2="49.18" />
        <rect class="htethd4"
              y="0.05"
              width="145.75"
              height="1.51" />
        <rect class="htethd4"
              x="154.25"
              width="145.75"
              height="1.5" />
        <text class="htethd5"
              transform="translate(113.22 84.2)">{{rangeModel.E}}</text>
        <text class="htethd5"
              transform="translate(64.22 84.2)">{{rangeModel.T}}</text>
        <text class="htethd5"
              transform="translate(16.22 84.2)">{{rangeModel.H}}</text>
        <text class="htethd5"
              transform="translate(170.22 84.2)">{{rangeModel.t}}</text>
        <text class="htethd5"
              transform="translate(218.22 84.2)">{{rangeModel.h}}</text>
        <text class="htethd5"
              transform="translate(267.22 84.2)">{{rangeModel.d}}</text>
        <path d="M278.65,17.33h2.64v18c0,.31,0,1.51.11,2.24h-2.63l-.06-2.24a3.93,3.93,0,0,1-1.26,1.48,6.34,6.34,0,0,1-3.47,1c-1.88,0-6.05-1-6.05-7.14,0-5.35,3.05-7.67,6.36-7.67a4.51,4.51,0,0,1,4.36,2.38Zm-1,9.05A3.8,3.8,0,0,0,274.59,25c-3.86,0-3.86,4.67-3.86,5.63,0,2.49.64,5.37,3.86,5.37,4.15,0,4.15-4.56,4.15-5.65A6,6,0,0,0,277.67,26.38Z"
              transform="translate(0 -1.32)" />
        <path d="M220.91,17.33h2.66v8.21a5.13,5.13,0,0,1,4.56-2.33c1.49,0,3.62.53,4.43,2.24a6.81,6.81,0,0,1,.47,3.28v8.79h-2.68V29.2c0-1.26,0-4-3-4A3.62,3.62,0,0,0,224,27.1a6.67,6.67,0,0,0-.45,3v7.45h-2.66Z"
              transform="translate(0 -1.32)" />
        <path d="M173.65,23.41h2.49V20.47l2.6-.84v3.78h3.14v1.93h-3.14v8.43c0,.7,0,1.87,1.88,1.87a5.62,5.62,0,0,0,1.26-.14v2a13.42,13.42,0,0,1-2.19.17c-2.4,0-3.55-.7-3.55-3V25.34h-2.49Z"
              transform="translate(0 -1.32)" />
        <path d="M152.52,82.16l-3.14,6.89h-1.9l1.79-6.89Z"
              transform="translate(0 -1.32)" />
    </svg>
</ng-template>

